
export const operationOptions = [
  { value: "IN", text: "Contains" },
  { value: "NOT_IN", text: "Does Not Contains" }
]

export const assetTypesOptions = [
  { value: 'PDF', label: 'PDF', icon: 'pdf' },
  { value: 'VIDEO', label: 'VIDEO', icon: 'video' },
  { value: 'IMAGE', label: 'IMAGE', icon: 'background' },
  { value: 'PPTX', label: 'PPTX', icon: 'pptx' },
  { value: 'PPT', label: 'PPT', icon: 'ppt' },
  { value: 'DOC', label: 'DOC', icon: 'doc' },
  { value: 'DOCX', label: 'DOCX', icon: 'docx' },
  { value: 'YOUTUBE', label: 'YOUTUBE', icon: 'YouTube-2' },
  { value: 'VIMEO', label: 'VIMEO', icon: 'Vimeo' },
  { value: 'WISTIA', label: 'WISTIA', icon: 'video' },
  { value: 'VIDYARD', label: 'VIDYARD', icon: 'video' },
  { value: 'LINK', label: 'LINK', icon: 'link' },
  { value: 'AUDIO', label: 'AUDIO', icon: 'audio' },
  { value: 'SCORM', label: 'SCORM', icon: 'content' },
  { value: 'LANDING_PAGE', label: 'LANDING PAGE', icon: 'landing-page'},
  { value: 'INTERACTIVE_CONTENT', label: 'INTERACTIVE CONTENT', icon: 'Interactive'},
  { value: 'RESOURCE_CENTER', label: 'RESOURCE CENTER', icon: 'resource-center'}
]

export const filterOptions = [{
  value: {
    type: 'ASSET'
  },
  label: 'Asset',
  data_type: 'asset',
  icon: 'doc',
  config: {

  }
}, {
  value: {
    type: 'FILE_TYPE'
  },
  label: 'File Type',
  data_type: 'list',
  icon: 'file-type',
  config: {
    multiple: true,
    options: assetTypesOptions
  }
}, {
  value: {
    type: 'TAGS'
  },
  label: 'Tags',
  data_type: 'tags',
  icon: 'tag',
  config: {
    multiple: true
  }
}]

export const conditions = [{
  type: 'list',
  options: [{
    value: 'IS',
    label: 'Is'
  }, {
    value: 'IS_NOT',
    label: 'Is Not'
  }, {
    value: 'IS_EMPTY',
    label: 'Is Empty'
  }, {
    value: 'IS_NOT_EMPTY',
    text: 'Is Not Empty'
  }]
}, {
  type: 'asset',
  options: [{
    value: 'IS',
    label: 'Is'
  }, {
    value: 'IS_NOT',
    label: 'Is Not'
  }, {
    value: 'IS_ALL',
    label: 'Is All'
  }]
}, {
  type: 'tags',
  options: [{
    value: 'IS',
    label: 'Is'
  }, {
    value: 'IS_NOT',
    label: 'Is Not'
  }, {
    value: 'IS_EMPTY',
    label: 'Is Empty'
  }, {
    value: 'IS_NOT_EMPTY',
    text: 'Is Not Empty'
  }]
}]

export const sortOptions = [{
  label: 'Name',
  value: 'name'
}, {
  label: 'Modified Date',
  value: 'modified_date'
}]

export const orderOptions = [{
  label: 'Ascending',
  value: 'ASC'
}, {
  label: 'Descending',
  value: 'DESC'
}]